import axiosInstance from "@API/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const useGetManyRequests = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const getAll = async (urls) => {
    setLoading(true);
    let responses = new Array(urls.length).fill(null);

    await Promise.all(
      urls.map((url, index) =>
        axiosInstance(url)
          .then((res) => {
            if (res.status != 200) {
              throw new Error("Internal Server Error"); // Force custom error message
            }
            return res.data;
          })
          .then((data) => {
            responses[index] = Array.isArray(data) ? data : [];
          })
          .catch((error) => {
            responses[index] = [];
            dispatch(
              setSnackbar({
                open: true,
                message:
                  typeof error.response?.data === "object"
                    ? error.response?.data.details
                    : error.response?.data,
                error: true,
              })
            );
          })
      )
    );
    setLoading(false);
    return responses;
  };
  return { loading, getAll };
};

export default useGetManyRequests;
